<span *ngIf="value">
  {{ getText() }}
</span>
